module.exports = __webpack_public_path__ + "static/media/no.e21b7ed3.svg";